export function isInvalidCryptoKey(value: string | Buffer): boolean {
  return value.length !== 32 && value.length !== 64;
}
